import { csrfRequest } from './helpers/request'
import {
  GENERIC_SERVER_ERROR_CODE,
  GENERIC_MFA_ERROR_CODE
} from '../../constants/error.codes'

export const revokeMFAMechanism = data => {
  const { mfaMechanism, password, recaptchaResponse } = data

  return csrfRequest({
    method: 'DELETE',
    url: '/users/mfa/' + mfaMechanism.toLowerCase(),
    headers: { 'Content-Type': 'application/json' },
    data: JSON.stringify({ password, recaptchaResponse })
  })
    .then(response => {
      if (response.status === 204) {
        return Promise.resolve(response)
      } else if (response.status >= 400 && response.status < 500) {
        return response.json().then(json => {
          return Promise.reject(new Error(json.code || GENERIC_MFA_ERROR_CODE))
        })
      } else {
        return Promise.reject(new Error(GENERIC_SERVER_ERROR_CODE))
      }
    })
    .catch(error => {
      throw error
    })
}
